import { ChevronDown, ChevronUp, Minus, Plus } from '@dreamstack/icons'
import type { SVGProps } from 'react'
import tw, { styled } from 'twin.macro'
import { GridWithGaps } from '../layout/MainGrid'
import { HeadingH2 } from '../layout/Texts'

export type WidgetType =
  | 'DefaultAccordion'
  | 'ExpandableBlock'
  | 'ArrowAccordion'

const StyledIconFactory = (icon: (props: SVGProps<any>) => JSX.Element) =>
  styled(icon)<{ $smallSize?: boolean }>(({ $smallSize }) => [
    !$smallSize && tw`ml:(h-px-64 w-px-64)`,
    tw`col-start-1 h-px-32 w-px-32 md:(col-start-1 justify-self-start) lg:(col-start-1 justify-self-end)`,
  ])
export const StyledPlus = StyledIconFactory(Plus)
export const StyledMinus = StyledIconFactory(Minus)
export const StyledChevronUp = StyledIconFactory(ChevronUp)
export const StyledChevronDown = StyledIconFactory(ChevronDown)

export const StyledPanelContent = styled.div<{
  smallSize?: boolean
  open: boolean
  widgetType?: WidgetType
  noMarginTop?: boolean
}>(({ smallSize, open, widgetType = 'DefaultAccordion', noMarginTop }) => [
  !open && tw`hidden`,
  tw`text-base text-accentroGray-full mt-px-24 md:mt-px-32 lg:mt-px-40`,
  smallSize && tw`col-start-2 col-span-10`,
  !smallSize && tw`col-start-3 col-span-10`,
  widgetType === 'ArrowAccordion' && tw`col-start-1`,
  noMarginTop && tw`mt-0 md:(mt-0) lg:(mt-0)`,
])

export const StyledGridWithGaps = styled(GridWithGaps)<{ useAqua?: boolean }>(
  ({ useAqua }) => [useAqua && tw`text-accentroAqua-full`, tw`items-center`]
)

export const StyledHeadingH2 = styled(HeadingH2)<{
  smallSize?: boolean
}>(({ smallSize }) => [
  tw`font-semibold col-span-full`,
  smallSize && tw`col-start-2 text-px-20`,
  !smallSize && tw`col-start-3`,
])

export const StyledDiv = styled.div<{ useAqua?: boolean }>(({ useAqua }) => [
  useAqua && tw`text-accentroAqua-full`,
  tw`items-center flex`,
])

export const PaddingContainer = styled.div<{ smallSize?: boolean }>(
  ({ smallSize }) => [
    smallSize && tw`py-px-24 md:py-px-32`,
    !smallSize && tw`py-px-24 ml:py-px-40 lg:py-px-64`,
  ]
)

export const expandableTitle = (
  title: string,
  titleWhenExpanded: string | undefined,
  open: boolean
) => {
  if (open) {
    return titleWhenExpanded ? titleWhenExpanded : title
  } else {
    return title
  }
}
